<template>
    <div class="">
        <Status />
        <br/>
        <Responsible />
        <Equipment v-if="['pedagog','it'].indexOf($store.state.type) === -1"/>
        <Teachers />
        <Courses />
        <div class="line"></div>
        <div class="title-part">Мероприятия</div>
        <Events />
        <div class="line"></div>
        <cooperation-member />
        <cooperation-partner />
        <cooperation-prof />
        <Graduates />
        <CountPupils />
    </div>
</template>

<script>
import Status from '../Status'
import Responsible from '../Responsible'
import Equipment from '../Equipment'
import Teachers from '../Teachers'
import Courses from '../Courses'
import Events from '../Events'
import Graduates from '../Graduates'
import CooperationMember from './cooperation/CooperationMember'
import CooperationPartner from './cooperation/CooperationPartner'
import CooperationProf from './cooperation/CooperationProf'
import CountPupils from '../count_pupils/CountPupils'
export default {
    name: "index",
    components: {
        Status,
        Responsible,
        Equipment,
        Teachers,
        Courses,
        Events,
        'cooperation-member': CooperationMember,
        'cooperation-partner': CooperationPartner,
        'cooperation-prof': CooperationProf,
        Graduates,
        CountPupils,
    },
}
</script>

<style scoped>

</style>
